<template>
  <div :class="$style.container">
    <div :class="[$style.header, $style.cursor]" @click="toggleContent">
      <Title :title-params="item.question_title" :class="$style.title" />
      <div :class="$style.iconContainer">
        <ChevronDownIcon
          height="20px"
          width="20px"
          :class="[$style.toggleIcon, { [$style.rotate]: !isHidden }]"
        />
      </div>
    </div>
    <div ref="body" :class="[$style.body]">
      <div ref="content" :class="$style.content">
        <RichText :text-params="item.question_content" />
        <div :class="$style.cta">
          <LkButton :href="getFormatedLink(item.question_link_url)">
            {{ item.question_link_text }}
          </LkButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChevronDownIcon from 'LkIcons/ChevronDown.vue'

import { getFormatedLink } from '~/mixins/getFormatedLink'
import Title from '~/components/Title'
import RichText from '~/components/RichText'
export default {
  name: 'FaqAccordion',
  components: { Title, RichText, ChevronDownIcon },

  mixins: [getFormatedLink],

  props: {
    item: {
      type: Object,
      required: true,
    },
    activeItem: {
      type: Number,
      default: null,
    },
    itemIndex: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isHidden: true,
    }
  },

  watch: {
    activeItem(now, prev) {
      if (now === this.itemIndex) {
        const offsetHeight = this.$refs.content.offsetHeight
        this.$refs.body.setAttribute('style', `height: ${offsetHeight}px`)
        this.isHidden = false
      } else {
        this.$refs.body.setAttribute('style', `height: 0`)
        this.isHidden = true
      }
    },
  },

  methods: {
    toggleContent() {
      this.isHidden = !this.isHidden
      this.$emit('select', {
        itemIndex: this.itemIndex,
        isHidden: this.isHidden,
      })
    },
  },
}
</script>

<style lang="scss" module>
.container {
  // padding: 24px 32px;
  border: 1px solid $gray-100;
  border-radius: 8px;

  @include below(small) {
    padding: 24px;
  }
}
.header {
  @include typo-headline;
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-weight: 500;
}

.body {
  height: 0;
  overflow: hidden;

  color: $gray-700;

  transition: height 0.2s ease-out;
}

.content {
  padding: 0 32px 24px;
}

.title {
  max-width: 90%;
  padding: 24px 32px;
  h3 {
    margin-bottom: 0;
  }
}

.cta {
  margin: 24px 0 0;

  text-align: center;
}

.cursor {
  cursor: pointer;
}

.iconContainer {
  display: flex;
  align-items: center;
  padding-right: 24px;
}

.toggleIcon {
  transition: transform 0.2s ease-out;
}
.rotate {
  transform: rotate(-180deg);
}
</style>
